import { Component } from "@angular/core";
import { AbstractModalComponent } from "../modal/abstract-modal.component";

@Component({
  standalone: false,
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html'
})
export class ConfirmModalComponent extends AbstractModalComponent {
  title: string;
  message: string;
  confirmButton: string;
}
